(function () {
  var footer = document.querySelector('.site-footer')
            || document.querySelector('footer')
            || document.querySelector('[id*="footer" i]');
  if (!footer || !('IntersectionObserver' in window)) return;
  new IntersectionObserver(function (entries) {
    document.body.classList.toggle('footer-in-view', entries[0].isIntersecting);
  }, { threshold: 0 }).observe(footer);
})();